import EmployeeLink, { EmployeeLinkProps } from './EmployeeLink';
import useIsEmployeeProfileAccessible from './permissions/useIsEmployeeProfileAccessible';

const EmployeeLinkWithAccessCheck = ({ id, ...props }: Omit<EmployeeLinkProps, 'isLink'>) => {
  const isProfileAccessible = useIsEmployeeProfileAccessible(id);

  return <EmployeeLink id={id} isLink={isProfileAccessible} {...props} />;
};

export default EmployeeLinkWithAccessCheck;
